import { ASSETS } from "@/lib/assets";
import { Reveal } from "@/components/site/Reveal";

const instruments = [
  {
    name: "VIBE",
    role: "The applicator",
    img: ASSETS.components.darkVibe,
    d: "A rechargeable handheld micro-jet. One press releases a fine, pressurized mist that carries your serum deep into the skin.",
  },
  {
    name: "DOSE",
    role: "The cartridges",
    img: ASSETS.components.darkDose,
    d: "Single-dose, NFC-tracked serum cartridges — filled regionally, sealed for hygiene, and logged automatically as you use them.",
  },
  {
    name: "GAZE",
    role: "The intelligence",
    img: ASSETS.components.darkGaze,
    d: "The companion app that scans your skin, classifies 11 conditions and decides the exact formulation VIBE delivers.",
  },
];

export const SystemSection = () => (
  <section id="system" className="relative py-28 md:py-40 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-6 items-end mb-16">
        <Reveal className="md:col-span-8">
          <p className="overline mb-5">The system</p>
          <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-[-0.02em]">
            One system.<br />Three instruments.
          </h2>
        </Reveal>
        <Reveal className="md:col-span-4" delay={0.1}>
          <p className="text-base text-muted-foreground leading-relaxed">
            Each part does one thing beautifully — together they form a closed loop that reads, personalizes and delivers.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-5">
        {instruments.map((it, i) => (
          <Reveal key={it.name} delay={i * 0.1}>
            <div className="group h-full rounded-2xl border border-white/10 bg-card overflow-hidden hover:border-primary/40 transition-colors duration-500">
              <div className="hover-media relative overflow-hidden aspect-[4/5] bg-[#0b0812]">
                <img
                  src={it.img}
                  alt={`ASYA ${it.name}`}
                  className="absolute inset-0 w-full h-full object-contain object-center p-4"
                />
                <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="p-8">
                <div className="flex items-baseline justify-between mb-4">
                  <h3 className="font-serif text-4xl tracking-[-0.02em]">{it.name}</h3>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                    {it.role}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed">{it.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
